import React from 'react';
import { format } from 'date-fns';
import { ChatMessage } from 'types';
import './style.less';

interface SessionChatSystemMessageProps {
  message: ChatMessage;
}

export const SessionChatSystemMessage: React.FC<SessionChatSystemMessageProps> = ({
  message,
}) => {
  return (
    <div className="SessionChatSystemMessage">
      <div className="SessionChatSystemMessage__center">
        <div className="SessionChatSystemMessage__center-action">{message.text}</div>
        &middot;
        <div
          className="SessionChatSystemMessage__center-action"
          title={new Date(message.timestamp).toString()}
        >
          {format(message.timestamp, 'p')}
        </div>
      </div>
    </div>
  );
};
